<div mat-dialog-content>
  <h1 mat-dialog-title>What is this?</h1>
  <button class="close-button" mat-icon-button aria-label="close dialog" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <div>
    <p>
      This is a tool that helps you explore and visualize your own Facebook Messenger History.
    </p>
  </div>

  <h1 mat-dialog-title>What am I seeing?</h1>
  <div>
    <p>
      In the central pane, you can see all your messages. Horizontally you've got the date, and vertically the time of
      day. Each dot represents a message that you sent or received. This central pane can be zoomed to see more detail
    </p>
    <p>
      Clicking the menu icon in the top left <mat-icon [color]="'primary'">menu</mat-icon>, will open a pane containing
      a list of all your chats. From here you can select and the central view will be updated accordingly. You can also
      give each chat a unique color by clicking the palette icon <mat-icon>palette</mat-icon> at the top of the pane.
    </p>
    <p>
      Clicking the <b>Filters</b> <mat-icon [color]="'primary'">filter_list</mat-icon> button in the top right
      will open a pane containing a bunch of histograms. These histograms give
      you statistics about your messages (number of messages sent, most active conversation, etc..),
      but more interestingly,  they allow you to filter your analysis. If you click on a bar, you
      can keep only the messages corresponding to this attribute, and all the other graphs will
      update automatically. This way, you can analyse for example who sends more messages in a
      particular conversation. Or what conversations are more active on the weekend versus during the week.
    </p>
    <p>
      Finally, if you mouse over the dots in the central pane, you can see
      the content of each message in the bottom right-hand corner of your screen.
    </p>
  </div>

  <h1 mat-dialog-title>How to proceed?</h1>
  <div>
    <p>
      The data displayed behind this window is random data. Do some tests to understand
      how it works, then click on "Explore my data" to play with your messages.
    </p>
    <p>
      Authors :
      <a href="https://github.com/MathReynaud"> Mathilde Reynaud </a> |
      <a href="https://github.com/adurivault"> Augustin Durivault </a>
      <br>
    </p>
  </div>
</div>
